import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';

//COMPONENTS
import AskGetLocation from './AskGetLocation';

//REDUX SELECTORS
import { displayAskGetLocationSelector } from './state/displayAskGetLocationSelector'

//REDUX ACTIONS
import { toggleAskGetLocation } from './state/displayAskGetLocationAction';

//UTILS
import introData from './introductionTextContent.json'

// UTILS
import { getCustomerInLS } from '../global/GlobalUtils';

//STYLE
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import './IntroductionSwiper.css'

// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

// Add dynamic styles for Swiper navigation/pagination
const addCustomerStyles = (styles) => {
    const styleId = 'customer-swiper-styles';
    let styleTag = document.getElementById(styleId);
    
    if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = styleId;
        document.head.appendChild(styleTag);
    }
    
    if (styles && Object.keys(styles).length > 0) {
        styleTag.textContent = `
            .swiper-pagination-bullet-active {
                background-color: ${styles.paginationColor || 'var(--cocoparksGreen)'} !important;
            }
            .swiper-button-prev,
            .swiper-button-next {
                color: ${styles.navigationColor || 'var(--cocoparksGreen)'} !important;
            }
        `;
    } else {
        styleTag.textContent = `
            .swiper-pagination-bullet-active {
                background-color: var(--cocoparksGreen) !important;
            }
            .swiper-button-prev,
            .swiper-button-next {
                color: var(--cocoparksGreen) !important;
            }
        `;
    }
};

const SlideContent = ({ item, customerStyles }) => {
    // Apply font and text-transform for Echinops-colored text (AMP client)
    const titleStyle = {
        color: customerStyles?.titleColor,
        fontFamily: customerStyles?.titleFontFamily,
        textTransform: customerStyles?.titleTextTransform
    };
    
    return (
        <>
            <h2 className="title-intro" style={titleStyle}>
                {item.title}
            </h2>
            <p className="content-intro" style={{ color: customerStyles?.contentColor }}>
                {item.content}
            </p>
        </>
    );
};

const SlideButton = ({ customerStyles, onClick }) => (
    <button 
        className="green-action-button" 
        style={{ 
            marginBottom: "25px",
            backgroundColor: customerStyles?.buttonColor,
            border: customerStyles?.buttonBorder,
            background: customerStyles?.buttonColor || undefined
        }}
        onClick={onClick}
    >
        <span className="green-action-button-text">C'est parti !</span>
    </button>
);

function IntroductionSwiper() {
    const config = useSelector((state) => state.config);
    const [customer, setCustomer] = useState(getCustomerInLS())
    const [filteredIntroData, setFilteredIntroData] = useState([]);
    const [customerStyles, setCustomerStyles] = useState({});
    const onboardingStatus = Array.from({ length: 4 }, (_, i) => config[`onboarding_step_${i + 1}`])
    const deactivateOnboardingAllSteps = onboardingStatus.every(value => value === false)
    

    const dispatch = useDispatch()

    const displayAskGetLocation = useSelector(displayAskGetLocationSelector)
    
    
    useEffect(() => {
        // Get customer data only once on component mount
        const customerFromLS = getCustomerInLS();
        setCustomer(customerFromLS);
    }, []);

    useEffect(() => {
        // Set filteredIntroData when customer is set
        if (customer) {
            const customerData = introData[customer] || {};
            
            if (customerData.styles && customerData.slides) {
                const hasCustomStyles = Object.keys(customerData.styles).length > 0;
                
                setCustomerStyles(hasCustomStyles ? customerData.styles : {});
                setFilteredIntroData(customerData.slides);
                addCustomerStyles(hasCustomStyles ? customerData.styles : {});
            } else {
                setCustomerStyles({});
                setFilteredIntroData(customerData);
                addCustomerStyles({});
            }
        }
    }, [customer]);
    
    /**
     * adds a 1 in local storage to ensure Cocoparks recognizes user has already connected
     * if not found, then considers first connection and shows tutorial
     */
    function incrementLocalStorage() {
        localStorage.setItem('knownCoco', '1');
    }

    // to display component AskGetLocation
    function showAskGetLocation() {
        dispatch(toggleAskGetLocation(true))
    }

    // if (deactivateOnboardingAllSteps) {
    //     if (displayAskGetLocation) {
    //         if (config.geolocalisation_searchbar) {
    //             return <AskGetLocation />
    //         } else {
    //             // document.location.reload(true)
    //             return null
    //         }
    //     } else {
    //         incrementLocalStorage();
    //         showAskGetLocation();
    //         return null;
    //     }
    // }

    if (displayAskGetLocation) {
        if (config.geolocalisation_searchbar) {
            return <AskGetLocation />
        } else {
            document.location.reload(true)
        }
    } else {
        const containerStyle = {
            backgroundColor: customerStyles?.backgroundColor || "var(--light-green)",
            width: "100vw",
            height: "100vh"
        };

        return (
            <div style={containerStyle}>
                <Swiper
                    pagination={{
                        "dynamicBullets": true,
                    }}
                    navigation={true}
                >
                    {filteredIntroData.map((item, key) => {
                        const isFirstSlide = key === 0 && customer !== 'default';
                        const isLastSlide = key === filteredIntroData.length - 1;
                        
                        return (
                            <SwiperSlide key={key} style={{ height: "85vh" }}>
                                {isFirstSlide && (
                                    <div className="intro-logo mx-2">
                                        <img src={item.imagePath} alt="phone" />
                                    </div>
                                )}
                                
                                <div className="introTop">
                                    <SlideContent item={item} customerStyles={customerStyles} />
                                </div>
                                
                                {!isFirstSlide && (
                                    <div className="intro-img">
                                        <img src={item.imagePath} alt="phone" />
                                    </div>
                                )}
                                
                                {isLastSlide && (
                                    <SlideButton 
                                        customerStyles={customerStyles} 
                                        onClick={() => { incrementLocalStorage(); showAskGetLocation() }} 
                                    />
                                )}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        )
    }
}

export default IntroductionSwiper
